import { buildCycleRecommendationRequestBody } from '@wix/package-picker-sdk';
import { getSearchParams } from '@wix/package-picker-shared';
import { useCurrentModule } from '../components';
import { eclipseServerData } from '../utils';
import { useCycleRecommendationEnabled } from './useCycleRecommendationEnabled';
const QUERY_OPTIONS = {
  staleTime: Infinity,
  refetchOnWindowFocus: false,
  useErrorBoundary: false,
  retry: false
};
const isTimeoutError = error => {
  const {
    code,
    message
  } = error ?? {};
  return code === 'ECONNABORTED' || /timeout/i.test(message ?? '');
};
export const useEclipseCycleRecommendation = () => {
  var _offering$discountInf;
  const module = useCurrentModule();
  const {
    isEligible,
    ineligibleReasons,
    isLoading: isEligibilityLoading
  } = useCycleRecommendationEnabled();
  const {
    siteGuid: contextSiteGuid
  } = module.internals.useContext();
  const {
    siteGuid: urlSiteGuid,
    referralAdditionalInfo
  } = getSearchParams();
  const {
    geo
  } = eclipseServerData.get();
  const {
    data: offering,
    isLoading: isOfferingLoading
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOffering({});
  const body = buildCycleRecommendationRequestBody({
    siteGuid: contextSiteGuid || urlSiteGuid,
    moduleName: module.moduleName,
    saleType: offering == null || (_offering$discountInf = offering.discountInfo) == null || (_offering$discountInf = _offering$discountInf.sale) == null ? void 0 : _offering$discountInf.saleType,
    geo,
    referral: referralAdditionalInfo
  });
  const {
    data,
    isLoading,
    isError,
    error
  } = module.SDK.cycleRecommendationApiClient.hooks.useGetCycleRecommendation(body, isEligible && !isOfferingLoading, QUERY_OPTIONS);
  return {
    cycleByFamily: (data == null ? void 0 : data.cycleByFamily) ?? {},
    correlationId: data == null ? void 0 : data.correlationId,
    isLoading: isEligibilityLoading || isEligible && (isOfferingLoading || isLoading),
    isError,
    isTimeout: isError && isTimeoutError(error),
    isEligible,
    ineligibleReasons
  };
};
//# sourceMappingURL=useEclipseCycleRecommendation.js.map